import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'App/styled';
import { selectCurrentSku, selectProductRelatedVideo } from 'shared/store/product/selector';
import { State } from 'shared/store/types';
import VideoPlayer from 'components/CustomVideoPlayer';
import { VIDEO_POSITION } from 'components/CustomVideoPlayer/constants';
import { MediaItem } from 'store/product/types';


interface SelectedMediaProps {
    setFullScreen: () => void;
    isVideoTab: boolean;
    Videos: MediaItem[];
    selectedVideo: any;
    newMedia: any;
    showFullScreen: boolean;
    selectedImage: any;
}


const SelectedImage = styled.div`
  flex: 2.6;
  img{
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: contain;
  }
`;

const SelectedVideoWrapper = styled.div`
  display:flex;
  flex-direction:column;
  flex: 2.6;
`;


const SelectedMedia = ({ isVideoTab, Videos, selectedVideo, newMedia, showFullScreen, setFullScreen, selectedImage }: SelectedMediaProps) => {
  const currentSku = useSelector((state: State) => selectCurrentSku(state));
  const relatedVideos = useSelector((state: State) => selectProductRelatedVideo(state)) || [];
  const slidePos = newMedia.findIndex(item => item?.id === selectedVideo?.id);

  return (
    <>
      {isVideoTab && Videos?.length > 0 ?
        <SelectedVideoWrapper>
          <VideoPlayer
            url={selectedVideo?.url}
            videoId={selectedVideo?.id}
            productId={currentSku?.childId}
            activeVideo={selectedVideo?.id}
            images={newMedia}
            relatedVideos={relatedVideos}
            videoPosition={VIDEO_POSITION.PDP}
            aspectRatio={selectedVideo?.aspectRatio}
            pdpVideoPosition={`carousel: ${slidePos + 1}`}
            showFullScreen={showFullScreen}
            setFullScreen={setFullScreen}
            title={selectedVideo?.title}
          />
        </SelectedVideoWrapper> :
        <SelectedImage >
          <img src={selectedImage.url} alt={selectedImage.type} />
        </SelectedImage>
                }
    </>
    );
};
export default SelectedMedia;
